import { Link } from "react-router-dom";
import { ArrowUpRight } from "lucide-react";
import { VERTICAL_REPARTI } from "@/lib/verticals";
import Seo, { breadcrumbJsonLd } from "@/components/Seo";

const ROLES = [
  { label: "CEO · C-level", desc: "Chief Executive, General Manager, Founders", to: "/per-chi-e/ceo-c-level" },
  { label: "Manager · Middle mgmt", desc: "Head of, Country Manager, Operations Director", to: "/per-chi-e/manager" },
  { label: "Senior specialist", desc: "Profili senior con expertise verticale", to: "/per-chi-e/senior-specialist" },
];

export default function PerChiE() {
  return (
    <>
      <Seo
        title="Per chi è Lovac, Ruoli, dipartimenti e verticali | Lovac"
        description="Lovac trova manager, CEO, profili sales, tech, finance, marketing, operations e HR. Esplora i verticali del nostro head hunting per PMI italiane."
        path="/per-chi-e"
        jsonLd={{
          "@context": "https://schema.org",
          "@type": "CollectionPage",
          name: "Verticali Lovac",
          url: "https://lovac.it/per-chi-e",
          inLanguage: "it-IT",
          breadcrumb: breadcrumbJsonLd([
            { name: "Home", path: "/" },
            { name: "Per chi è", path: "/per-chi-e" },
          ]),
        }}
      />
      <section className="bg-lovac-dark text-on-dark grain relative overflow-hidden">
        <div className="container-lovac px-6 pt-24 pb-20 relative z-10">
          <span className="badge-on-dark">Per chi è</span>
          <h1 className="font-display text-5xl sm:text-6xl mt-6 text-on-dark max-w-3xl">
            Verticali specifici. Recruiter dedicati.
          </h1>
          <p className="text-on-dark-muted text-lg mt-6 max-w-2xl">
            Non ci occupiamo di tutto. Ci specializziamo nella ricerca di figure qualificate, senior e manageriali. Ogni area di Lovac è seguita da un team dedicato, con competenze verticali, network specifico e conoscenza diretta del mercato di riferimento.
          </p>
        </div>
      </section>

      <section className="section bg-lovac">
        <div className="container-lovac">
          <p className="badge-lovac">Per reparto</p>
          <h2 className="font-display text-4xl mt-4 text-lovac-dark">Scegli il reparto</h2>
          <div className="grid md:grid-cols-2 gap-5 mt-10">
            {VERTICAL_REPARTI.map((v) => (
              <Link key={v.key} to={`/per-chi-e/${v.key}`} className="card-lovac group block no-underline">
                <div className="flex items-start justify-between mb-4">
                  <span className="badge-lovac">{v.short}</span>
                  <ArrowUpRight size={18} className="text-lovac-muted group-hover:text-lovac-accent transition-colors" />
                </div>
                <h3 className="font-display text-2xl text-lovac-dark">{v.label}</h3>
                <p className="text-sm text-lovac-muted mt-3">{v.subtitle}</p>
              </Link>
            ))}
          </div>
        </div>
      </section>

      <section className="section bg-lovac-2">
        <div className="container-lovac">
          <p className="badge-lovac">Per ruolo</p>
          <h2 className="font-display text-4xl mt-4 text-lovac-dark">Per seniority</h2>
          <div className="grid md:grid-cols-3 gap-5 mt-10">
            {ROLES.map((r) => (
              <div key={r.label} className="card-lovac">
                <h3 className="font-display text-xl text-lovac-dark">{r.label}</h3>
                <p className="text-sm text-lovac-muted mt-2">{r.desc}</p>
                {r.to && (
                  <Link to={r.to} className="link-underline text-sm text-lovac-dark mt-4 inline-block">
                    Approfondisci →
                  </Link>
                )}
              </div>
            ))}
          </div>
        </div>
      </section>
    </>
  );
}
